import { ComponentFactoryResolver, Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ao-container]'
})
export class AOContainerDirective {

  private _component: any = null;

  constructor(
    private _content: ViewContainerRef,
    private _resolver: ComponentFactoryResolver
  ) {
  }

  component() {
    return this._component;
  }

  content() {
    return this._content;
  }

  clear() {
    this.content().clear();
  }

  open(component: any) {
    this.clear();

    this._component = this.content().createComponent(
      typeof component !== 'function' ? component : this._resolver.resolveComponentFactory(component)
    );

    this._component.instance.directive = this;

    return this._component.instance;
  }

}
